export const teoriaEdicionContrato = [
    {
      title: "¿Por qué editar y personalizar un contrato inteligente ERC20 antes de desplegarlo?",
      value: `
  Antes de lanzar un contrato inteligente en la red de Ethereum (o cualquier blockchain compatible), es fundamental entender **qué estás editando** y **por qué se utiliza un estándar como ERC20**.
  
  ---
  
  **¿Por qué el estándar ERC20?**  
  ERC20 es el estándar más reconocido y utilizado para crear tokens fungibles en Ethereum y redes compatibles como Polygon.  
  Utilizar un contrato ERC20 te garantiza compatibilidad con exchanges, wallets y dApps, ya que todos reconocen este formato y saben cómo interactuar con él.  
  Además, es una base sólida para construir aplicaciones financieras, realizar transferencias automatizadas y llevar un control de balances y aprobaciones de manera segura y auditada.
  
  ---
  
  **¿Qué necesitas antes de editar tu contrato inteligente?**  
  Para personalizar correctamente tu contrato y prepararlo para tokenizar cualquier activo (como bienes raíces, acciones o incluso utilidades de una plataforma), **asegúrate de tener lo siguiente a la mano**:
  
  1. **Tu contrato base o plantilla ERC20**  
     Es el código fuente que copiaste de un repositorio confiable, como GitHub. Este archivo será la base sobre la que harás todos tus cambios y personalizaciones.
  
  2. **El documento legal o el contrato del activo que vas a tokenizar**  
     Por ejemplo, si estás tokenizando un inmueble, ten a la mano el contrato de compraventa o de propiedad en PDF.  
     Deberás adaptar la información clave de ese documento a los campos y variables del contrato inteligente.
  
  3. **La dirección de tu wallet**  
     Esta es la dirección pública de tu wallet en Ethereum o Polygon (empieza con 0x...).  
     Es importante porque al desplegar el contrato, el total de los tokens generados quedarán asignados inicialmente a esta dirección.
  
  4. **Tu editor de texto con el contrato listo para editar**  
     Abre Sublime Text, VS Code o el editor de tu preferencia, y carga la plantilla del contrato.  
     Esto te permitirá hacer cambios rápidos y guardar tu progreso antes de compilar o desplegar.
  
  ---
  
  **¿Qué tipo de ediciones se suelen realizar?**  
  - Cambiar el **nombre** y **símbolo** del token para personalizarlo (por ejemplo: de "TootyrToken" a "RealEstateToken").
  - Ajustar el **número total de tokens** y la cantidad de decimales.
  - Ingresar la dirección de tu wallet como la propietaria inicial de los tokens.
  - Agregar comentarios, enlaces o metadatos para documentar la finalidad del contrato.
  
  ---
  
  **Importancia de editar tu propio contrato:**  
  Personalizar tu contrato no solo le da identidad a tu token, sino que también te ayuda a comprender su funcionamiento, asegurando que los parámetros iniciales sean exactamente los que necesitas para tu proyecto.
  
  Recuerda: **editar y entender el contrato antes de desplegarlo es fundamental para la seguridad y éxito de tu tokenización**.
  
  
  `
    }
  ];
  
  export default teoriaEdicionContrato;
  